const VALUES = [
    {display:'Monthly',     value:'M'},
    {display:'Quarterly',   value:'Q'},
    {display:'Semi-Annual', value:'S'},
    {display:'Annual',      value:'A'},
    {display:'At Maturity', value:'F'}
]

export const COUPON_FREQUENCIES = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdCouponPayFrequency=' + value
        }
    })

export const COUPON_FREQUENCY_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))



// WEBPACK FOOTER //
// ./src/twd/values/coupon-frequencies.js